import React from 'react'
import { Typography } from '@mui/material';
import {t} from 'i18next';

type NoResultsprops = {
    title?: string;
}

const AurNoResults:React.FC<NoResultsprops> = () => {
    return (
        <div className='no-result-area'>
            <div className="blank-area">
                <Typography  className='typo-text headline2_size mist-100'>
                    {t('common.noResults')}
                </Typography>
                <img src="/assests/images/no_results.svg" alt="no-results" className='blue-image'/>
            </div>
        </div>
    )
}
export default AurNoResults